import Store from './reduxStore.js'
import request from 'request'
import axios from 'axios';
import * as Actions from './redux-actions.js'
import * as globals from './globals.js'

axios.defaults.withCredentials = true;

// parseUrl usage example:
// parseUrl('http://mysite:5050/pke45#23')
//    {origin: "http://mysite:5050", host: "mysite:5050", hostname: "mysite", pathname: "/pke45", port: "5050"…}
// parseUrl('http://mysite:5050/pke45#23', 'origin')
//   "http://mysite:5050"
export const parseUrl = (string, prop) =>  {
  const a = document.createElement('a'); 
  a.setAttribute('href', string);
  const {host, hostname, pathname, port, protocol, search, hash} = a;
  const origin = `${protocol}//${hostname}${port.length ? `:${port}`:''}`;
  return prop ? eval(prop) : {origin, host, hostname, pathname, port, protocol, search, hash}
}


var isMessageVisible = function () {
  return Store.getState().alert && Store.getState().alert.visible === true
}

export var alertMessage = function (message, type=globals.INFO, visible=true, hidein) {
 if (isMessageVisible()) { return } 
  let timeOut
  if (hidein > 0) {
    timeOut = setTimeout(closeMessage, hidein)
  }
  Store.dispatch({type: Actions.SET_ALERT, alert: {type: type, visible: visible, message: message, timeout: timeOut}})
}

export var closeMessage = function (toId) {
  Store.dispatch({type: Actions.SET_ALERT, alert: {visible: false}})
}



export var setServerOFF = function () {
  Store.dispatch({type: Actions.SET_SERVER_STATUS, value: false })
}

export var setServerON = function () {
  Store.dispatch({ type: Actions.SET_SERVER_STATUS, value: true })
}

// getAPI is function used to get data from API, all data passed in JSON format.
// Function gets as argument "action" which is objects of next form:
//   {func: function(data, response, error) { actions with data}, uri: 'some uri', showLastMessage: true || false}
// For each new action handler must be added in this function.
var stopper = {}
export var getAPI = function (action, rCounter=0, retryCount=globals.apiReqRetry, retryTimeOut=globals.apiReqTimeout) {
	if (rCounter < retryCount ) {
	console.log('Getting data from ' + action.uri +', try:', rCounter);
	axios.get(action.uri, {validateStatus: function (status) {
                                         return ( status >= 200 && status < 300 ) || status == 503 || status == 401;}})
             .then((response) => {
                parseUrl(action.uri, 'origin') === globals.myServer && setServerON() 
                action.func(response.data, response)
                return true
             })
             .catch((error) => {
                  console.log('DEBUG error response', error)
                  parseUrl(action.uri, 'origin') === globals.myServer && setServerOFF() 
           	   	  console.log('Cannot get data from API, Error: ', error.message || error.response.data);
                  closeMessage()
                  alertMessage('Cannot get data from the server, will try after ' + retryTimeOut(rCounter)/1000 + ' sec. Try number: ' + rCounter, globals.ERRO)
                  rCounter++
                  // Executing recursively  with timeout. Passing arguments in setTimeout
                  setTimeout(getAPI, retryTimeOut(rCounter), action, rCounter, retryCount, retryTimeOut)
           	   	  return false;
           	   });
      
    } else
      {
           if (action.showLastMessage === undefined || action.showLastMessage === true) {
              alertMessage('Cannot get data from the server after all ' + retryCount + ' tries! Please try the operation later.', globals.ERRO)
           } else {
                closeMessage()
           }         
           console.log('RETRIES FINISHED!')
           parseUrl(action.uri, 'origin') === globals.myServer && setServerON() 
           action.func(null, null, 'FAILED')

       }
    
}



export var postAPI = function (action, rCounter=0, retryCount=globals.apiReqRetry, retryTimeOut=globals.apiReqTimeout) {
  if (rCounter < retryCount ) {
  console.log('Putting data to ' + action.uri +', try:', rCounter);
  axios.post(action.uri, action.data, {validateStatus: function (status) {
                                                           return ( status >= 200 && status < 300 ) || status == 503 || status == 401;}})
             .then((response) => {
                 parseUrl(action.uri, 'origin') === globals.myServer && setServerON() 
                 action.func(response.data, response)
                 return true
             })
             .catch((error) => {

                   parseUrl(action.uri, 'origin') === globals.myServer && setServerOFF() 
                   console.log('Cannot put data to API, Error: ', error.message || error.response.data);
                   console.log('Try', rCounter)
                   closeMessage()
                   alertMessage('Cannot put data to the server, will try after ' + retryTimeOut(rCounter)/1000 + ' sec. Try number: ' + rCounter, globals.ERRO)
                   rCounter++
                   // Executing recursively  with timeout. Passing arguments in setTimeout
                   setTimeout(postAPI, retryTimeOut(rCounter), action, rCounter, retryCount, retryTimeOut)
                   return false;
               });
      
    } else
      {
           if (action.showLastMessage === undefined || action.showLastMessage === true) {
              alertMessage('Cannot put data to the server after all ' + retryCount + ' tries! Please try the operation later.', globals.ERRO)
           } else {
                closeMessage()
           }         
           console.log('RETRIES FINISHED!')
           parseUrl(action.uri, 'origin') === globals.myServer && setServerON() 
           action.func(null, null, 'FAILED')

       }
    
}



export var mapElementToValue = function(Obj) {
    let Data = {}
    let key
    for (key of Object.keys(Obj)) {
         Data[key] = Obj[key].value
    }
    return Data
  }



export var mapFormToData = function(Form) {
	let Data = {}
	let key
    for (key of Object.keys(Form)) {
       if (key.substring(key.lastIndexOf("_")) !== "_default") {
         Data[key.split('_')[1]] = Form[key].value
       }
    }
    return Data
}


export var validate = function(what, value) {
  let RE
  switch (what) {
    case 'required':
         if (! value || value.length <= 0 || value.length === "null") {
           return false
         } else {
           return true
         }
      break;

    case 'email':
        RE=/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        return RE.test(value)
     break;
    
    case 'phone':
        RE=/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g
        return RE.test(value)
      break;

    case 'password':
         if (! value || value.length <= 4 || value.length === "null") {
           return false
         } else {
           return true
         }
      break;


    case 'flight_number':
        RE=/^[A-Za-z0-9]+$/g
        return RE.test(value)
      break;

    case 'all_valid':
        return Object.keys(value).every((k) => value[k])


    default:
      return true 
  }

}
